"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _AppAssetSection_asset2 = _interopRequireDefault(require("./__generated__/AppAssetSection_asset.graphql"));
var _InternalDeleteAppAsset2 = _interopRequireDefault(require("./__generated__/InternalDeleteAppAsset.graphql"));
var _InternalChooseAppAsset2 = _interopRequireDefault(require("./__generated__/InternalChooseAppAsset.graphql"));
var _InternalUploadAppAsset2 = _interopRequireDefault(require("./__generated__/InternalUploadAppAsset.graphql"));
var React = _interopRequireWildcard(require("react"));
var _useCandidateAction2 = require("web/shared/imageCandidates/useCandidateAction");
var _reactRelay = require("react-relay");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ImageCandidateStrip = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateStrip"));
var _genMutate = require("web/shared/relay/genMutate");
var _styles = require("web/shared/assets/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One declared app asset: its key, what it is for, and its candidates in
* the shared picture strip. Busy state and errors are the section's own,
* so one asset's refusal never holds the others; the candidates are the
* page's, reloaded after every action.
*/
const INTERNAL_UPLOAD_APP_ASSET = _InternalUploadAppAsset2.default;
const INTERNAL_CHOOSE_APP_ASSET = _InternalChooseAppAsset2.default;
const INTERNAL_DELETE_APP_ASSET = _InternalDeleteAppAsset2.default; /**
                                                                    * Add a candidate to a declared app asset — chosen when it
                                                                    * had none, a candidate otherwise. The server decides the format from the
                                                                    * bytes and refuses anything but a PNG, JPEG or WebP, anything over its size
                                                                    * limit, or a key no screen declares, in its own words.
                                                                    */
async function _genUploadAppAsset(assetKey, file) {
  const data = await (0, _genMutate.genMutate)(INTERNAL_UPLOAD_APP_ASSET, {
    assetKey,
    file
  });
  return data.internalUploadAppAsset;
} /** Make this candidate the picture every screen gets. */
async function _genChooseAppAsset(candidateId) {
  const data = await (0, _genMutate.genMutate)(INTERNAL_CHOOSE_APP_ASSET, {
    candidateId
  });
  return data.internalChooseAppAsset;
} /**
  * Remove a candidate. The server refuses the chosen one, in
  * the rule's words.
  */
async function _genDeleteAppAsset(candidateId) {
  const data = await (0, _genMutate.genMutate)(INTERNAL_DELETE_APP_ASSET, {
    candidateId
  });
  return data.internalDeleteAppAsset;
} // Short, since several assets share the page.
const ASSET_STRIP_HEIGHT = "14rem";
const ASSET_WORDING = {
  listLabel: "Candidates",
  chosenName: "Chosen picture",
  candidateName: "Candidate",
  viewName: "Picture",
  uploadLabel: "Upload picture",
  dropNote: "Drop to upload as a candidate",
  loadingNote: "Loading candidates…",
  emptyNote: "No candidates yet.",
  chooseLabel: "Use this picture",
  alreadyChosen: "This picture is already the one screens get.",
  nowChosen: "This picture is now the one screens get.",
  deleteTitle: "Delete this candidate",
  cannotDeleteChosen: "You can't delete the selected picture.",
  deleteDialogTitle: "Are you sure you want to delete this candidate?",
  deleteConfirmLabel: "Delete candidate"
}; // What this section draws of an asset. Declared here rather than selected by
// the page, so a field this section starts or stops reading is a change to
// this file alone.
const ASSET = _AppAssetSection_asset2.default;
function AppAssetSection(props) {
  const asset = (0, _reactRelay.useFragment)(ASSET, props.asset);
  const onChanged = props.onChanged;
  const _useCandidateAction = (0, _useCandidateAction2.useCandidateAction)(onChanged),
    busy = _useCandidateAction.busy,
    error = _useCandidateAction.error,
    act = _useCandidateAction.act;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.section)), {}, {
    "aria-label": asset.key,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.titleRow)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.title)), {}, {
        children: asset.key
      }))
    })), asset.declared ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.purpose)), {}, {
      children: asset.purpose
    })) : null, props.hasBucket ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateStrip.default, {
      candidates: asset.candidates // The boundary above owns waiting, so by the time a section
      // renders its candidates are already here.
      ,
      loading: false,
      busy: busy,
      error: error,
      lastIsProtected: false,
      wording: ASSET_WORDING,
      deleteMessage: candidate => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("code", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.fact)), {}, {
          children: candidate.objectKey
        })), " ", "will be removed from the bucket production serves. This action cannot be undone."]
      }),
      onUpload: file => act(() => _genUploadAppAsset(asset.key, file)),
      onChoose: candidateId => act(() => _genChooseAppAsset(candidateId)),
      onDelete: candidateId => act(() => _genDeleteAppAsset(candidateId)),
      testIdPrefix: "asset-".concat(asset.key),
      height: ASSET_STRIP_HEIGHT
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.status)), {}, {
      children: "This product has no bucket configured, so there is nothing to upload to."
    }))]
  }));
}
var _default = exports.default = AppAssetSection;